import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Question: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={18}
      height={18}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M9.053 5.741A1.39 1.39 0 007.61 7.137l-1.5.006a2.89 2.89 0 114.085 2.619.89.89 0 00-.445.838v.4h-1.5v-.386a2.39 2.39 0 011.308-2.21 1.39 1.39 0 00-.505-2.663zM9 14a1 1 0 100-2 1 1 0 000 2z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 .25a8.75 8.75 0 100 17.5A8.75 8.75 0 009 .25zM1.75 9a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z'
        fill='currentColor'
      />
    </svg>
  </i>
);

Question.displayName = 'Question';
export default Question;
